import React from 'react';

export default (props) => {

  return (
    <div className="detail-view">
      <p>{props.recipe.ingredients}</p>
      <a href={props.recipe.link}><p>recipe link</p></a>
      <button
        className="btn btn-edit"
        onClick={()=>{
          const addForm = document.getElementsByClassName("add-form");
          const recipeName = document.getElementById("recipe-name");
          addForm[0].classList.toggle("add-form-active");
          recipeName.value = props.recipe.name;
          recipeName.readOnly = true;

        }}
      >edit</button>
      <button className="btn btn-delete" onClick={()=>{
        props.remove(props.recipe.name);
      }}>delete</button>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/RecipeDetail.js
 **/